import PaymentAPI from "@/app/apis/main/payment/payment-api.js"

export default {
	/**
	 * @param petId
	 * @param paymentDetails
	 * @return {object} No content
	 */
	async chargePayment(petId, paymentDetails) {
		return PaymentAPI.chargePayment(petId, paymentDetails)
	},

	/**
	 * @param petId
	 * @param paymentDetails
	 * @return {object} No content
	 */
	async subscriptionPayment(petId, paymentDetails) {
		return PaymentAPI.subscriptionPayment(petId, paymentDetails)
	},

	/**
	 * @param paymentDetails
	 * @return {object}
	 */
	async lattitudePayment(paymentDetails) {
		return PaymentAPI.lattitudePayment(paymentDetails)
	},

	/**
	 * @param paymentDetails
	 * @return {object}
	 */
	async updateStatusLatitudePay(paymentDetails) {
		return PaymentAPI.updateStatusLatitudePay(paymentDetails)
	},

	/**
	 * @param paymentDetails
	 * @return {object}
	 */
	async latitudePaymentPublic(paymentDetails) {
		return PaymentAPI.latitudePaymentPublic(paymentDetails)
	},

	/**
	 * @param paymentDetails
	 * @return {object}
	 */
	async updateStatusLatitude(paymentDetails) {
		return PaymentAPI.updateStatusLatitude(paymentDetails)
	},

	/**
	 * @param paymentDetails
	 * @return {object}
	 */
	async proceedToLatitude(paymentDetails) {
		return PaymentAPI.proceedToLatitude(paymentDetails)
	},

	/**
	 * @param paymentDetails
	 * @return {object}
	 */

	async proceedToLatitudeInterestFree(paymentDetails) {
		return PaymentAPI.proceedToLatitudeInterestFree(paymentDetails)
	},

	async proceedProductToLatitudeInterestFree(paymentDetails) {
		return PaymentAPI.proceedProductToLatitudeInterestFree(paymentDetails)
	},

	/**
	 * @param paymentDetails
	 * @return {object}
	 */
	async verifyLatitude(paymentDetails) {
		return PaymentAPI.verifyLatitude(paymentDetails)
	},

	async getLatitudeInterestFreeUrl(orderId) {
		return PaymentAPI.getLatitudeInterestFreeUrl(orderId)
	},

	async getLatitudeInterestFreeUrlForProductPurchase(puppyPurchaseId) {
		return PaymentAPI.getLatitudeInterestFreeUrlForProductPurchase(puppyPurchaseId)
	},

	async getLatitudeInterestFreeUrlForProductPurchasePublic(queryParams) {
		return PaymentAPI.getLatitudeInterestFreeUrlForProductPurchasePublic(queryParams)
	},

}
